import {IssueType} from "../domain/entities/issue-type.entity";
import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

export class CreateIssueTypeCommand extends AbstractCommand<IssueType> {

    public name: CommandName = CommandName.CREATE_ISSUE_TYPE;

    public tags = ['entity', 'create', 'issue-type'];

    constructor(payload: IssueType) {
        super('issue-type', payload.uid, payload);
    }
}